module.exports = __webpack_public_path__ + "static/pew-europe-religion-902b883cc2e9e7ad5ed433ae888da840.png";